import React, { useState, useContext } from "react";
import styled, { css } from "styled-components";
import Input from "./Input";
import Notification from "./Notification";
import { ReactComponent as At } from "../assets/svg/at.svg";
import { ReactComponent as Eye } from "../assets/svg/eye.svg";
import { ReactComponent as EyeLock } from "../assets/svg/eye-lock.svg";
import { ReactComponent as Phone } from "../assets/svg/phone.svg";
import Button from "./Button";
import UserAPI from "../apis/UserAPI";
import Modal from "./Modal";
import StampMessage from "./StampMessage";
import { useHistory } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";

const Profile = () => {
  const userContext = useContext(UserContext);

  let history = useHistory();

  const [name, setName] = useState(userContext.name);
  const [lastname, setLastname] = useState(userContext.lastname);
  const [phone, setPhone] = useState(userContext.phone);
  const [email, setEmail] = useState(userContext.email);
  const [password, setPassword] = useState("");
  const [passwordNew, setPasswordNew] = useState("");
  const [passwordRepeated, setPasswordRepeated] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showState, setShowState] = useState(false);

  const save = () => {
    if (loading) return;

    setLoading(true);

    const sanitized = {
      name: name?.trim() || "",
      lastname: lastname?.trim() || "",
      phone: phone?.toString().replace(/\D/g, "") || "",
      passwordNew: passwordNew,
      passwordRepeated,
      password,
    };

    let notification = null;
    if (sanitized.name === "") notification = "Tu nombre es incorrecto.";
    else if (sanitized.lastname === "")
      notification = "Tus apellidos son incorrectos.";
    else if (sanitized.phone === "")
      notification = "El celular o teléfono fijo es incorrecto.";
    else if (sanitized.passwordNew !== sanitized.passwordRepeated)
      notification = "Las contraseñas no coinciden.";
    else if (
      sanitized.passwordNew.length > 0 &&
      sanitized.passwordRepeated.length > 0 &&
      ((!sanitized.passwordNew.length > 3 &&
        sanitized.passwordNew.length < 21) ||
        !(
          sanitized.passwordRepeated.length > 3 &&
          sanitized.passwordRepeated.length < 21
        ))
    )
      notification = "Tu nueva contraseña debe tener entre 4 y 20 caracteres.";
    else if (
      sanitized.password.length === 0 &&
      (sanitized.passwordNew > 0 || sanitized.passwordRepeated > 0)
    )
      notification = "Tu actual contraseña es incorrecta.";

    if (notification) {
      setNotification(notification);
      setLoading(false);
    } else {
      setNotification(null);
      UserAPI.updateProfile(sanitized)
        .then(() => {
          setShowState("SUCCESS");
          setPassword("");
          setPasswordNew("");
          setPasswordRepeated("");
        })
        .catch((error) => {
          setNotification(error);
          setShowState("FAILURE");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const ModalState = (
    <ModalStyled>
      <ContainerState>
        {showState === "SUCCESS" && (
          <StampMessage success text="Cambios guardados" />
        )}
        {showState === "FAILURE" && (
          <StampMessage wrong text="Ocurrió un error" />
        )}
        <ButtonState
          text="OK"
          tertiary
          onClick={() => setShowState(false)}
          loading={loading}
        />
      </ContainerState>
    </ModalStyled>
  );

  return (
    <Container>
      <Wrapper>
        {showState && ModalState}
        <Title>Perfil</Title>
        {notification && <NotificationStyled message={notification} />}
        <InputStyled
          placeholder="Nombre"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <InputStyled
          placeholder="Apellidos"
          value={lastname}
          onChange={(e) => setLastname(e.target.value)}
        />
        <InputStyled
          placeholder="Celular o teléfono fijo"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          icon={<InputIcon as={Phone} />}
        />
        <InputStyled
          placeholder="Correo"
          disabled
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          icon={<InputIcon as={At} />}
        />
        <InputStyled
          placeholder="Nueva contraseña"
          autocomplete="new-password"
          value={passwordNew}
          onChange={(e) => setPasswordNew(e.target.value)}
          type={showPassword ? "text" : "password"}
          icon={
            passwordNew.length > 0 && (
              <InputIcon
                button
                as={showPassword ? EyeLock : Eye}
                onClick={() => setShowPassword((state) => !state)}
              />
            )
          }
        />
        <InputStyled
          placeholder="Repita la contraseña"
          autocomplete="new-password"
          value={passwordRepeated}
          onChange={(e) => setPasswordRepeated(e.target.value)}
          type={showPassword ? "text" : "password"}
          icon={
            passwordRepeated.length > 0 && (
              <InputIcon
                button
                as={showPassword ? EyeLock : Eye}
                onClick={() => setShowPassword((state) => !state)}
              />
            )
          }
        />
        <InputStyled
          placeholder="Contraseña actual"
          disabled={!(passwordNew.length > 0 || passwordRepeated.length > 0)}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type={showPassword ? "text" : "password"}
          icon={
            password.length > 0 && (
              <InputIcon
                button
                as={showPassword ? EyeLock : Eye}
                onClick={() => setShowPassword((state) => !state)}
              />
            )
          }
        />
        <Buttons>
          <ButtonStyled
            text="Cancelar"
            secondary
            onClick={() => history.goBack()}
          />
          <ButtonStyled
            text="Guardar"
            loading={loading}
            primary
            onClick={save}
          />
        </Buttons>
      </Wrapper>
    </Container>
  );
};


const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 270px;
  width: 100%;

  padding: 5px;
  box-sizing: border-box;
`;

const Title = styled.div`
  align-self: flex-start;
  font-size: 1.5em;
  font-weight: 600;

  margin-bottom: 25px;
`;

const NotificationStyled = styled(Notification)`
  margin: 0px 0px 20px 0px;
`;

const InputStyled = styled(Input)`
  margin-bottom: 10px;
`;

const InputIcon = styled.div`
  padding: 8px 10px;
  min-width: 18px;
  min-height: 18px;
  width: 18px;
  height: 18px;
  margin: auto 0;
  fill: rgba(0, 0, 0, 0.5);

  ${(props) =>
    props.button &&
    css`
      cursor: pointer;
    `}
`;

const ButtonStyled = styled(Button)`
  margin: 15px 0px;
`;

const Buttons = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 240px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

const ModalStyled = styled(Modal)`
  max-width: 220px;
  width: 100%;
`;

const ContainerState = styled.div`
  padding: 20px;
  & > * {
    margin: 5px;
  }
`;

const ButtonState = styled(Button)`
  margin-top: 30px;
`;

export default Profile;
